import RootState from 'typings/RootState'
import { Event } from 'Store/common/common.types'
import {
  ListData,
  Data,
  RequestProducts,
  ProductOptionsWithMaterail,
  ImportFileProductCheckingRes,
  ProductImportCreate,
  LogProducts,
  ApproveListRes,
  ApproveDetailData,
} from './types'

export const selectListEvent = (state: RootState): Event => state.productReducer.listEvent

export const selectList = (state: RootState): ListData => state.productReducer.list

export const selectActionEvent = (state: RootState): Event => state.productReducer.actionEvent

export const selectDetail = (state: RootState): Data | undefined => state.productReducer.detail

export const selectDetailEvent = (state: RootState): Event => state.productReducer.detailEvent

export const selectMasterProductList = (state: RootState): ListData => state.productReducer.masterProductsList

export const selectRequestProductsList = (state: RootState): ApproveListRes =>
  state.productReducer.requestProducts

export const selectAllProductList = (state: RootState): ListData => state.productReducer.allProductList

export const selectBomDetail = (state: RootState): ProductOptionsWithMaterail[] =>
  state.productReducer.bomDetail

export const selectBomDetailEvent = (state: RootState): Event => state.productReducer.bomDetailEvent

export const selectCheckingProducts = (state: RootState): ImportFileProductCheckingRes =>
  state.productReducer.checkingProductFile

export const selectCheckingProductsEvent = (state: RootState): Event =>
  state.productReducer.checkingProductFileEvent

export const selectLastProductImport = (state: RootState): ProductImportCreate[] =>
  state.productReducer.lastProductsImport

export const selectImportProductEvent = (state: RootState): Event => state.productReducer.importProductEvent

export const selectLogProductsList = (state: RootState): LogProducts =>
  state.productReducer.logRequestProducts

export const selectApproveProductEvent = (state: RootState): Event =>
  state.productReducer.requestProductDetailEvent

export const selectApproveProductDetail = (state: RootState): ApproveDetailData | undefined =>
  state.productReducer.requestProductDetail
